import { UserLevelConfigItem } from "../../../queries/services/rewards/getUserLevelConfig";

export const FALLBACK_LEVEL_CONFIG: UserLevelConfigItem[] = [
  { level: 1, xpNeeded: 0, pointsReward: 500, pcTokensReward: 0 },
  { level: 2, xpNeeded: 500, pointsReward: 1100, pcTokensReward: 10 },
  { level: 3, xpNeeded: 1000, pointsReward: 1150, pcTokensReward: 10 },
  { level: 4, xpNeeded: 1500, pointsReward: 1200, pcTokensReward: 10 },
  { level: 5, xpNeeded: 2000, pointsReward: 1250, pcTokensReward: 10 },
  { level: 6, xpNeeded: 2500, pointsReward: 1300, pcTokensReward: 10 },
  { level: 7, xpNeeded: 3000, pointsReward: 1350, pcTokensReward: 10 },
  { level: 8, xpNeeded: 3500, pointsReward: 1400, pcTokensReward: 10 },
  { level: 9, xpNeeded: 4000, pointsReward: 1450, pcTokensReward: 10 },
  { level: 10, xpNeeded: 4500, pointsReward: 1500, pcTokensReward: 70, milestones: { referralThaw: true, rarePassDormant: true } },
  { level: 11, xpNeeded: 5300, pointsReward: 1550, pcTokensReward: 10 },
  { level: 12, xpNeeded: 6100, pointsReward: 1600, pcTokensReward: 10 },
  { level: 13, xpNeeded: 6900, pointsReward: 1650, pcTokensReward: 10 },
  { level: 14, xpNeeded: 7700, pointsReward: 1700, pcTokensReward: 10 },
  { level: 15, xpNeeded: 8500, pointsReward: 1750, pcTokensReward: 10 },
  { level: 16, xpNeeded: 9500, pointsReward: 1800, pcTokensReward: 10 },
  { level: 17, xpNeeded: 10500, pointsReward: 1850, pcTokensReward: 10 },
  { level: 18, xpNeeded: 11500, pointsReward: 1900, pcTokensReward: 10 },
  { level: 19, xpNeeded: 12500, pointsReward: 1950, pcTokensReward: 10 },
  { level: 20, xpNeeded: 13700, pointsReward: 2000, pcTokensReward: 70, milestones: { questXPMultiplier: "1.05", cashInjection: "small" } },
  { level: 21, xpNeeded: 14900, pointsReward: 2050, pcTokensReward: 10 },
  { level: 22, xpNeeded: 16100, pointsReward: 2100, pcTokensReward: 10 },
  { level: 23, xpNeeded: 17300, pointsReward: 2150, pcTokensReward: 10 },
  { level: 24, xpNeeded: 18500, pointsReward: 2200, pcTokensReward: 10 },
  { level: 25, xpNeeded: 19700, pointsReward: 2250, pcTokensReward: 10, milestones: { rarePassActive: true } },
  { level: 26, xpNeeded: 20700, pointsReward: 2300, pcTokensReward: 10 },
  { level: 27, xpNeeded: 21700, pointsReward: 2350, pcTokensReward: 10 },
  { level: 28, xpNeeded: 22700, pointsReward: 2400, pcTokensReward: 10 },
  { level: 29, xpNeeded: 23700, pointsReward: 2450, pcTokensReward: 10 },
  { level: 30, xpNeeded: 24700, pointsReward: 2500, pcTokensReward: 100, milestones: { questXPMultiplier: "1.10", cashInjection: "mid" } },
  { level: 31, xpNeeded: 25700, pointsReward: 2550, pcTokensReward: 10 },
  { level: 32, xpNeeded: 26700, pointsReward: 2600, pcTokensReward: 10 },
  { level: 33, xpNeeded: 27700, pointsReward: 2650, pcTokensReward: 10 },
  { level: 34, xpNeeded: 28700, pointsReward: 2700, pcTokensReward: 10 },
  { level: 35, xpNeeded: 29700, pointsReward: 2750, pcTokensReward: 10 },
  { level: 36, xpNeeded: 30700, pointsReward: 2800, pcTokensReward: 10 },
  { level: 37, xpNeeded: 31700, pointsReward: 2850, pcTokensReward: 10 },
  { level: 38, xpNeeded: 32700, pointsReward: 2900, pcTokensReward: 10 },
  { level: 39, xpNeeded: 33700, pointsReward: 2950, pcTokensReward: 10 },
  { level: 40, xpNeeded: 34700, pointsReward: 3000, pcTokensReward: 100, milestones: { questXPMultiplier: "1.15", cashInjection: "large" } },
  { level: 41, xpNeeded: 35700, pointsReward: 3050, pcTokensReward: 10 },
  { level: 42, xpNeeded: 36700, pointsReward: 3100, pcTokensReward: 10 },
  { level: 43, xpNeeded: 37500, pointsReward: 3150, pcTokensReward: 10 },
  { level: 44, xpNeeded: 38300, pointsReward: 3200, pcTokensReward: 10 },
  { level: 45, xpNeeded: 39100, pointsReward: 3250, pcTokensReward: 10 },
  { level: 46, xpNeeded: 39900, pointsReward: 3300, pcTokensReward: 10 },
  { level: 47, xpNeeded: 40700, pointsReward: 3350, pcTokensReward: 10 },
  { level: 48, xpNeeded: 41500, pointsReward: 3400, pcTokensReward: 10 },
  { level: 49, xpNeeded: 42300, pointsReward: 3450, pcTokensReward: 10 },
  { level: 50, xpNeeded: 44500, pointsReward: 3500, pcTokensReward: 210, milestones: { rarePassActive: true, paragonMode: true } },
];
